import { Container, Stars } from './style'
import { Rocket } from './rocket'

export function Home() {
  return(
    <Container>
        <div className="fill"></div>

        <div className="containerTextHome">
        
            <h1 className="textHome first"> Bem-vindo ao seu </h1>
            <h1 className="textHome second"> 
                Painel  <span className="purple">Administrativo</span>
            </h1>
            <Stars>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
            </Stars>
        

          <Rocket />
          
        </div>

    </Container>
  ) 
}
